import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'

function Footer() {
    return (
        <footer id="footer">
            <div className="footer-top">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-sm-2"><a href="https://sigarra.up.pt/feup/pt/web_page.inicial"><img className="footer-logo" src="./img/logo-feup.png" /></a></div>
                        <div className="col-sm-2"><a href="https://deq.fe.up.pt/"><img className="footer-logo" src="./img/logo-deq.png" /></a></div>
                        <div className="col-sm-5"></div>
                        <div className="col-sm-1"><a href="https://pt-pt.facebook.com/neeqfeup" className="footer-icon">
                            <FontAwesomeIcon icon={faFacebookF} />
                        </a>
                        </div>
                        <div className="col-sm-1"><a href="https://www.instagram.com/neeqfeup" className="footer-icon">
                            <FontAwesomeIcon icon={faInstagram} />
                            </a>
                        </div>
                        <div className="col-sm-1">
                            <a href="https://www.linkedin.com/company/neeq-feup/" className="footer-icon">
                                <FontAwesomeIcon icon={faLinkedinIn} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;